import { Formik, Form, Field, ErrorMessage } from 'formik'
import { object, string, number, array, boolean, date, addMethod } from 'yup';
import FieldWrapper from '../forms/FieldWrapper'
import ImageDisplayAndUpload from './fields/ImageDisplayAndUpload'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import WrapperAccordion from '../general/WrapperAccordion';
import DatePickerContainer from './fields/DatepickerContainer'
import RadioButtonGroup from './fields/RadioButtonGroup'
import MultiselectCheckboxCinemas from './fields/MultiselectCheckboxCinemas'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import RadioButton from './fields/RadioButton'
import config from '../../attribute-position-config.json'
import addFormikData from '../../functions/addFormikData'
import Translation from '../Translation/cont/Translation'
import { withRouter } from 'react-router-dom'
import configAdvertisements from '../../config-advertisements'
import { ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_HOME_BANNER_SINGLE, ADVERTISEMENT_MAIN_SLIDER, ADVERTISEMENT_OVERVIEW_BANNER } from '../../constants/advertisementTypes';

const HOME_BANNER_TYPES = [ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_HOME_BANNER_SINGLE]

const getImageDefaults = (type) => {
    if (!configAdvertisements.images.hasOwnProperty(type)) return {}
    return Object.keys(configAdvertisements.images[type]).reduce((acc, key) => ({ ...acc, [key]: null }), {})
}

const HomeBannerToggle = ({ type, setFieldValue }) => {
    if (!HOME_BANNER_TYPES.includes(type)) return null

    const isSingle = type === ADVERTISEMENT_HOME_BANNER_SINGLE

    return (
        <div className="advertisement-format-toggle">
            <span className="toggle-label">Home Banner</span>
            <label>
                <input
                    type="checkbox"
                    className="checkbox tgl tgl-flat"
                    checked={isSingle}
                    onChange={() => {
                        const newType = isSingle ? ADVERTISEMENT_HOME_BANNER : ADVERTISEMENT_HOME_BANNER_SINGLE
                        setFieldValue('type', newType)
                        setFieldValue('images', getImageDefaults(newType))
                    }}
                />
                <span className="tgl-btn text-regular"></span>
            </label>
            <span className="toggle-label">Home Banner Single</span>
        </div>
    )
}

const FormAdvertisementsImages = ({type, sliderAppearance, bannerAppearance, errors, validate}) => {
    const isSlim = 'slim_advertisement_slider' === sliderAppearance && ADVERTISEMENT_MAIN_SLIDER === type
    const bannerIsSlim =  'slim' === bannerAppearance && ADVERTISEMENT_OVERVIEW_BANNER === type 

    return (
        configAdvertisements.images.hasOwnProperty(type) ? (
            <div className="">
                {Object.keys(configAdvertisements.images[type]).map(key => {
                    const config = configAdvertisements.images[type][key]

                    const width = isSlim ? 'desktop' === key ? 1920 : 1200 : config.width
                    const height = isSlim ? 'desktop' === key ? 600 : 1200 : bannerIsSlim && key === 'mobile' ? 220 : config.height

                    return (
                        <FieldWrapper 
                            label={<Translation id={config.transId}/>}
                            id={`content-image-${key}`}
                            classes='field-images'
                            key={key} 
                        >
                            <div className="advertisement-notice text-small-light">
                                <Translation id="advertisement_image_size_start"/> {width} x {height} px <Translation id="advertisement_image_size_end"/>
                            </div>
                            
                            <Field 
                                name={`images.${key}`}
                                component={ImageDisplayAndUpload}
                                imageSize={{
                                    width: width,
                                    height: height,
                                    relativeTo: config.relativeTo
                                }}
                            />

                            {errors && <div className="error-message text-regular-color"><Translation id="error_no_image"/></div>}
                        </FieldWrapper>
                    )
                })}
            </div>
        ) : ''
    )
}

const FormAdvertisements = ({
    itemData,
    history,
    closePagePath,
    cliCinemas, 
    cliCinemasIdList, 
    clientCinemaId, 
    features, 
    sliderAppearance,
    bannerAppearance,
    onUpdateItem
}) => {
    const {  destinationType, pathType } = config
    const cinemaDomain = cliCinemas[clientCinemaId].website

    const newLinkData = {
        destinationType: "external",
        pathType: "absolute",
        url: "",
        text: null
    }

    const linkData = itemData.link ? itemData.link : newLinkData

    const validationSchema = (props) => object().noUnknown({onlyKnownKeys : true}).shape({
        title: string().required(),
        draft: boolean(),
        active: boolean(),
        displayDateStart: date(),
        displayDateEnd: date(),
        order: array(),
        cinema: string(),
        images: object(),
        cinemasFilter: array(),
        type: string().required(),
        link: object(),
        pk: string(),
        showInApp: boolean(),
        updatedAt: date(),
        createdAt: date(),
    })
    
    const validate = (values) => {
        const errors = {};
        
        const {images} = values
        const isEmpty = images ? Object.values(images).every(x => x === null || x === '') : true

        if(isEmpty) {
            errors.images = 'Required!'
        }
      
        return errors;
    };

    return (
        <Formik
            initialValues={addFormikData(sanitizeFormInput(itemData, cliCinemas), linkData, "link")}
            validationSchema={(values) => validationSchema(values)}
            validate={(values) => validate(values)}
            onSubmit={(values, actions) => {
                const copyValues = structuredClone(values)

                if(!copyValues.link.url) {
                    copyValues.link = null
                }

                if(copyValues.images) {
                    Object.entries(copyValues.images).forEach(([key, value]) => {
                        if(!value) {
                            delete copyValues.images[key]
                        }
                    })

                    if(0 === Object.keys(copyValues.images).length) {
                        copyValues.images = null
                    }
                }

                onUpdateItem(sanitizeFormOutput(copyValues))

                actions.setSubmitting(false)
            }}
            onReset={() => {
                history.push(closePagePath)
        }}>
        {({ values, errors, isSubmitting, setFieldValue, handleReset }) => (
            <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >

                        <fieldset>
                            <div className="form-content advertisement">
                                <div className="left-sections">
                                    <FieldWrapper label={<Translation id="advertisement_title"/>} id="content-title" classes="field-text">
                                        <Field type="text" name="title" id="content-title" className="text-regular input-text-box" />
                                        <ErrorMessage name="title" component="div" className="error-message text-regular-color"/>
                                    </FieldWrapper>

                                    <HomeBannerToggle
                                        type={values.type}
                                        setFieldValue={setFieldValue}
                                    />

                                    <FormAdvertisementsImages
                                        type={values.type}
                                        sliderAppearance={sliderAppearance}
                                        bannerAppearance={bannerAppearance}
                                        errors={errors && errors.hasOwnProperty('images') ? errors.images : false}
                                    />
                                    
                                    <FieldWrapper label={<Translation id="content_link_url"/>} id="content-link-url" classes="field-text">
                                        <Field type="text" name="link.url" id="content-link-url" className="text-regular input-text-box" />
                                        <ErrorMessage name="link.url" component="div" /> 
                                    </FieldWrapper>

                                    <RadioButtonGroup
                                        label={<Translation id="content_link_target"/>}
                                        description={<Translation id="content_link_target_info"/>}
                                        className="select-new-section-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="link.destinationType" component="div" /> 
                                        {destinationType.map(type => {
                                            const {transId, id} = type
                                            
                                            return (
                                                <Field
                                                    key={id}
                                                    component={RadioButton}
                                                    name="link.destinationType"
                                                    id={id}
                                                    label={<Translation id={transId}/>}
                                                />
                                            )
                                        })}
                                    </RadioButtonGroup>

                                    <RadioButtonGroup
                                        label={<Translation id="content_link_type"/>}
                                        description={<Translation id="content_link_type_info" after={' ' + cinemaDomain}/>}
                                        className="select-new-section-type"
                                    >
                                        <ErrorMessage className="text-regular-color movie-error" name="link.pathType" component="div" /> 

                                        {pathType.map(type => {
                                            const {transId, id} = type
                                            return (
                                                <Field
                                                    key={id}
                                                    component={RadioButton}
                                                    name="link.pathType"
                                                    id={id}
                                                    label={<Translation id={transId}/>}
                                                />
                                            )
                                        })}
                                    </RadioButtonGroup>

                                    <div className="active-container">
                                        <FieldWrapper label={<Translation id="weischer_activate" />} id="content-title" classes="">
                                            <div className="field-checkbox">
                                                <label>
                                                    <Field
                                                        type="checkbox" name="active"
                                                    />
                                                    <span className="text-small-regular">
                                                        <Translation id="weischer_item_active" />
                                                    </span>
                                                </label>
                                                <ErrorMessage className="text-regular-color" name="active" component="div" /> 
                                            </div>
                                        </FieldWrapper>  
                                    </div>

                                    <div className="datepicker-container">
                                        <div className="datepicker-wrapper">
                                            {_.has(values, "displayDateStart") && <FieldWrapper label={<Translation id="content_display_start_date"/>} id="startdate" description={<Translation id="advertisement_display_start_date_info"/>} classes="datepicker-inner-wrapper">
                                                <DatePickerContainer value={values.displayDateStart} isStartDate={true} resetValue={'displayDateEnd'} end={values.displayDateEnd} name="displayDateStart" onChange={setFieldValue} type="text" id="startdate" className="text-small-light input-text-box" />
                                                <ErrorMessage name="displayDateStart" component="div" />
                                            </FieldWrapper>}
                                        </div>
                                        <div className="datepicker-wrapper">
                                            {_.has(values, "displayDateEnd") && <FieldWrapper label={<Translation id="content_display_end_date"/>} id="enddate" description={<Translation id="advertisement_display_end_date_info"/>} classes="datepicker-inner-wrapper">
                                                <DatePickerContainer value={values.displayDateEnd} start={values.displayDateStart} name="displayDateEnd" onChange={setFieldValue} type="text" id="enddate" className="text-small-light input-text-box" />
                                                <ErrorMessage name="displayDateEnd" component="div" />
                                            </FieldWrapper>}
                                        </div>
                                    </div>
                                    
                                
                                    {_.has(values, "cinema") && cliCinemas ? (
                                        cliCinemasIdList.length > 1 ? (
                                            <fieldset className="field-cinemas">
                                                    <legend className="field-text-label"><Translation id="content_cinemas"/></legend>                                                
                                                    <div className="select-all-cinemas-button-wrapper">  
                                                        <div key={'field-all'} className="field-checkbox">
                                                            <Field 
                                                                key={'all'} 
                                                                attrid={'all'}
                                                                name="cinemas"
                                                                component={MultiselectCheckboxCinemas} 
                                                                id={'alle anwählen'}
                                                                clicinemas={'all'}
                                                                value={cliCinemasIdList} 
                                                            />
                                                        </div>
                                                    </div>
    
                                                    <div className="grid-container">
                                                        {cliCinemasIdList.map(cinemaId => {
                                                            const cinema = cliCinemas[cinemaId]
                                                            const {pk, nameShort} = cinema

                                                            return (
                                                                <div key={'field' + pk} className="field-checkbox">
                                                                    <Field 
                                                                        key={pk} 
                                                                        attrid={pk}
                                                                        name="cinemas"
                                                                        component={MultiselectCheckboxCinemas} 
                                                                        id={nameShort}
                                                                        clicinemas={cliCinemas}
                                                                        value={pk}
                                                                    />
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </fieldset>
                                            ) : (
                                                cliCinemasIdList.map(cinemaId => {
                                                    const cinema = cliCinemas[cinemaId]
                                                    const {pk, nameShort} = cinema
                                                    
                                                    return (
                                                        <div key={'field' + pk} className="field-checkbox">
                                                            <Field 
                                                                key={pk} 
                                                                attrid={pk}
                                                                name="cinemas"
                                                                component={MultiselectCheckboxCinemas} 
                                                                id={nameShort}
                                                                clicinemas={cliCinemas}
                                                                value={pk} 
                                                            />
                                                        </div>
                                                    )
                                                })
                                            )
                                        ) : (
                                            ''
                                        )
                                    }

                                    {/* {features && features.has_mcs_app && <div className="field-checkbox field-text">
                                        <label>
                                            <p className="field-text"><Translation id="app_settings"/></p>
                                            <Field type="checkbox" name="showInApp" id="show-in-app" className="checkbox"/>
                                            <span className="show-in-app-text text-regular"><Translation id="app_display" /></span>
                                        </label>
                                        <ErrorMessage className="text-regular-color" name="showInApp" component="div" />
                                    </div> }                               */}
                                </div>
                            </div>
        
                            <ButtonSubmitCancel
                                transIdCancel="cancel_button"
                                transIdSubmit="save_advertisement_button"
                                disabledCancel={isSubmitting}
                                disabledSubmit={isSubmitting}
                                onCancel={handleReset}
                            />
                        </fieldset>
                    </WrapperAccordion>
                </Form>
            )}
        </Formik>
    )

}

export default withRouter(FormAdvertisements)